import * as Yup from 'yup'

import { REPORT_FILE_TYPE } from '../../../../../pages/Partnerships/PartnershipRightsList/helpers'

export const FILE_TYPE = 'type'
export const NEW_FILES = 'new_files'
export const EXISTED_FILES = 'existed_files'

const checkIfFileTypeAvailable = (fileTypesList, typeToFind) =>
  !!fileTypesList.find(fileType => fileType.value === typeToFind)

export const getInitialValues = ({ existedFiles, preselectedFileType, availableFileTypesList }) => {
  let fileType

  if (preselectedFileType && checkIfFileTypeAvailable(availableFileTypesList, preselectedFileType)) {
    fileType = preselectedFileType
  } else if (checkIfFileTypeAvailable(availableFileTypesList, REPORT_FILE_TYPE)) {
    fileType = REPORT_FILE_TYPE
  } else {
    fileType = availableFileTypesList[0].value
  }

  return {
    [NEW_FILES]: [],
    [EXISTED_FILES]: existedFiles || [],
    [FILE_TYPE]: fileType
  }
}

export const validationSchema = Yup.object({})
